module.exports = __webpack_public_path__ + "static/media/new-domain-br.72a82a21.png";